import type { ChipProps } from "@mui/material/Chip";

// Локальный маппинг типа/статуса обращения: admin не переиспользует
// partner/site локализацию, здесь нет i18n (см. соседние feature: refunds).
export const typeLabel: Record<string, string> = {
  REFUND: "Возврат",
  ACCESS_PROBLEM: "Проблема с доступом",
  PAYMENT_PROBLEM: "Проблема с оплатой",
  OTHER: "Другое",
};

export const typeOptions = Object.entries(typeLabel).map(([value, label]) => ({
  value,
  label,
}));

export const statusLabel: Record<string, string> = {
  DRAFT: "Черновик",
  OPEN: "Новое",
  WAITING_VIEWER: "Ждём зрителя",
  VIEWER_REPLIED: "Ответил зритель",
  CLOSED: "Решено",
  CANCELLED: "Отменено",
};

export const statusChipColor: Record<string, ChipProps["color"]> = {
  DRAFT: "default",
  OPEN: "warning",
  WAITING_VIEWER: "info",
  VIEWER_REPLIED: "error",
  CLOSED: "success",
  CANCELLED: "default",
};

export const statusOptions = Object.entries(statusLabel).map(
  ([value, label]) => ({ value, label })
);
